module.exports = __webpack_public_path__ + "d0adb7e3403a487648fd00b4fe69a674.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/scene-snapper.png
// module id = 2603
// module chunks = 0